'use client';
import { CardItemEntity } from '@entities/desktop/cards';
import { ProductsQuery } from '@hooks/queries/common.types';
import { useProducts } from '@hooks/queries/use-query-products';
import { ListCardsWidget } from '@widgets/desktop';
import React from 'react';
import { useMediaQuery } from 'usehooks-ts';

import { Label } from '@/shared/ui';

import styles from './similar-in-price-items.module.scss';

export const SIMILAR_IN_PRICE_QUERY_KEY = 'similar-in-price-products' as const;

export const getSimilarInPriceQueryFilters = (pageParam: number) => {
  const query: ProductsQuery = {
    filter: {
      search: '',
      types: [
        {
          type: 'pet',
        },
        {
          type: 'egg',
        },
        {
          type: 'potion',
        },
        {
          type: 'transport',
        },
      ],
      onlyHotSales: true,
      onlyNew: false,
      onlyExclusive: false,
      onlyDiscount: false,
    },
    order: {
      by: 'price',
      direction: 'desc',
    },
    page: 0,
    limit: 10,
  };

  return query;
};

export const SimilarInPriceItems = () => {
  const { isLoading, items, isFetching } = useProducts({
    getQueryFiltersFn: getSimilarInPriceQueryFilters,
    uniqueQueryKey: SIMILAR_IN_PRICE_QUERY_KEY,
  });

  //@todo виртуализация

  const isLargeScreen = useMediaQuery('(min-width: 1920px)');
  const isMediumScreen = useMediaQuery('(min-width: 1440px)');
  const isSmallScreen = useMediaQuery('(min-width: 1024px)');

  const slicesItems = items;

  return (
    <ListCardsWidget
      className={styles['container']}
      cardsVariant={'secondary'}
      topSlot={
        <Label
          labelVariant={'yellow'} //
          icon={'graph-up'}
          variant={'primary'}
        >
          Items similar in price
        </Label>
      }
      isLoading={isFetching}
      bottomSlot={
        <>
          {slicesItems.map((item, index) => (
            <CardItemEntity
              applyHandleClickOnFullCard
              isMM2Variant={false}
              variant={'primary'}
              key={`card-${index}-${item.realName}-${item?.name}`}
              item={item}
            />
          ))}
        </>
      }
    />
  );
};
